<template>
  <v-card class="search-results" tile flat>
    <v-list flat>
      <v-list-item-group dense>
        <template v-for="(item, idx) in results">
          <search-tile
            :key="idx"
            @click.native="selectWork(item)"
            :image="item.image"
            :title="item.title"
            :subtitle="item.subtitle"
          ></search-tile>
        </template>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<style scoped></style>

<script>
import { getSubtitleFromWork } from "../../util/mediumHelpers";

export default {
  name: "search-results",

  props: {
    search: { type: String, default: "" },
    medium: { type: String, default: "album" },

    delay: { type: Number, default: 250 },
  },

  data: () => ({
    results: [],
    searchDelay: undefined,
    latestTimeOfSearch: 0,
  }),

  watch: {
    search: function () {
      window.clearTimeout(this.searchDelay);
      this.searchDelay = window.setTimeout(this.runSearch, this.delay);
    },
  },

  methods: {
    runSearch: function () {
      const timeOfSearch = Date.now();
      this.$axios
        .get("/v1/search", {
          params: {
            q: this.search,
            category: this.medium,
            limit: 20,
          },
        })
        .then((response) => {
          if (timeOfSearch < this.latestTimeOfSearch) {
            return;
          }
          const items = response.data.items;
          // If no data found exit
          if (items.length === 0) {
            this.results = [];
            return;
          }
          this.results = items.map((item) => ({
            image: item.posterSource,
            title: item.title,
            subtitle: this.getSubtitleFromWork(item),
            id: item.id,
          }));
          this.latestTimeOfSearch = timeOfSearch;
        })
        .catch((error) => {
          console.error(error);

          this.results = [];
        });
    },

    async selectWork(item) {
      this.$emit("click", item.id);
    },

    getSubtitleFromWork,
  },
};
</script>
